import './theme_fcg.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeFcg implements ITheme {
    id: string = 'fcg';
    matchIfHostNameContainsAny: string[] = ['fcg'];
    name: string = 'Fcg';
    cssClassName: string = 'theme_fcg';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#005192',
        secondary: '#e95d0e',
        accent: '#e95d0e',
        warning: '#e95d0e',
        bottomNavColor: '#ffffff',
    };
}
